import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2575117d&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=2575117d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2575117d",
  null
  
)

export default component.exports